import { isIos } from "../pwa/platform";

/**
 * Chrome fijo del admin en iPhone (Eduardo 2026-10-02: «al bajar desaparecen
 * la categoría y los botones de arriba»): iOS Safari amplía la página cuando
 * se toca un campo con letra de menos de 16px y no la regresa sola. Ampliada,
 * el header y el nav de torneo/categoría (position: fixed) se quedan pegados
 * a la vista sin ampliar y se salen de la pantalla al bajar.
 *
 * El asistente tiene ~24 tipos de campo de menos de 16px (ranking, formato,
 * tablas, formularios); subirlos todos a 16px rompería el diseño compacto y
 * cortaría los nombres de categoría. En su lugar, solo en iOS, se agrega
 * `maximum-scale=1` al viewport: iOS deja de ampliar al tocar un campo y,
 * desde iOS 10, Safari sigue permitiendo ampliar con dos dedos. En Android no
 * se toca (ahí `maximum-scale` sí bloquearía el zoom con dos dedos y Chrome no
 * amplía al tocar campos).
 */
export function viewportWithoutFocusZoom(content: string): string {
  if (/(^|,)\s*maximum-scale\s*=/i.test(content)) return content;
  const trimmed = content.trim().replace(/,\s*$/, "");
  return trimmed ? `${trimmed}, maximum-scale=1` : "maximum-scale=1";
}

type PlatformInfo = Pick<Navigator, "userAgent" | "maxTouchPoints">;

/** Devuelve true si ajustó el viewport (solo iPhone/iPad). */
export function preventIosFocusZoom(doc: Document = document, platform: PlatformInfo = navigator): boolean {
  if (!isIos(platform.userAgent, platform.maxTouchPoints ?? 0)) return false;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return false;
  const next = viewportWithoutFocusZoom(meta.getAttribute("content") ?? "");
  if (next !== meta.getAttribute("content")) meta.setAttribute("content", next);
  return true;
}
